import React, { useEffect } from 'react';
import Cookies from 'js-cookie';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import { Button } from '@itds/elements/index.js';
import { Colors } from '@itds/Theme';

const Authenticated = () => {
  const navigate = useNavigate();
  const styles = {
    header: {
      background: Colors.GRAY.hex,
      padding: '0 20px',
      marginBottom: '40px',
      display: 'flex',
      alignItems: 'center'
    },
    header_link: {
      color: '#fff',
      textDecoration: 'none',
      padding: '33px 15px',
      fontWeight: 500,
      position: 'relative',
      cursor: 'pointer'
    },
    header_link_active_after: {
      content: '',
      display: 'block',
      width: '0',
      height: '0',
      position: 'absolute',
      bottom: '0',
      borderBottom: '10px solid #fff',
      borderLeft: '10px solid transparent',
      borderRight: '10px solid transparent',
      left: '50%',
      transform: 'translateX(-50%)'
    },
    logo: {
      backgroundImage: "url('https://ixn.s3.us-west-2.amazonaws.com/prod/img/logo_white.png')",
      backgroundSize: 'contain',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      width: '70px',
      height: '34px',
      marginRight: '40px',
      cursor: 'pointer'
    },
    body_sand: { paddingTop: '52px' },
    body_sand_before: {
      content: "'SAND ENVIRONMENT'",
      padding: '20px',
      display: 'block',
      background: '#969088',
      fontWeight: 600,
      letterSpacing: '20px',
      textAlign: 'center',
      position: 'fixed',
      top: '0',
      left: '0',
      right: '0',
      zIndex: 10,
      fontSize: '12px',
      color: 'rgba(0, 0, 0, 0.4)'
    },
    footer: {
      textAlign: 'center',
      padding: 50
    }
  };

  useEffect(() => {
    // TODO: Secure this more by validating the jwt from the cookie
    if (!Cookies.get('control-room-b')) {
      navigate('/');
    }
  }, []);

  const logout = () => {
    Cookies.remove('control-room-b');
    navigate('/');
  };
  const iconClicked = () => {
    navigate('/');
  };

  return (
    <>
      <div style={styles.header}>
        <div onClick={iconClicked} style={styles.logo} />
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {[
            { label: 'Agencies', to: 'agencies' },
            { label: 'Members', to: 'members' },
            { label: 'Mobile Apps', to: 'mobile_apps' },
            { label: 'Config Fields', to: 'config_fields' },
            { label: 'Admins', to: 'admins' },
            { label: 'Carriers', to: 'carriers' },
            { label: 'ApiTokens', to: 'api_tokens' }
          ].map((link, i) => {
            return (
              <Link
                key={i}
                // onClick={navigate.bind(null, `/${link.to}`)}
                style={styles.header_link}
                to={`/${link.to}`}
              >
                {link.label}
                {window.location.hash.split('/')[1] === link.to ? (
                  <div style={styles.header_link_active_after} />
                ) : null}
              </Link>
            );
          })}
        </div>
        <Button
          color='RED'
          icon='logout'
          onClick={logout}
          small={true}
          style={{ marginLeft: 'auto' }}
        >
          Log Out
        </Button>
      </div>

      <Outlet />

      <footer style={styles.footer}>&copy; {format(new Date(), 'yyyy')} IXN</footer>
    </>
  );
};

export default Authenticated;
